import { useModulesGetModuleByModuleIdQuery } from '@app/services/auto-generated/modules'

interface Accent {
  code: string
  name: string
  flag_image: string
}

const useAccents = () => {
  const { data, isLoading, isSuccess } = useModulesGetModuleByModuleIdQuery({
    moduleId: 'PreferredAccentModule',
  })

  const languages: Accent[] = data ? data.config.accents : []

  const getAccentFromCode = (languageCode: string) => {
    const target = languages.find((lng) => lng.code === languageCode)
    return target
  }

  const enhanceAccents = (accent) => {
    const acc = languages.filter((lang) => lang.code === accent)
    if (acc.length === 0) {
      return null
    }
    return acc[0]
  }

  return { languages, isLoading, getAccentFromCode, enhanceAccents, isSuccess }
}

export default useAccents
